import { DATASET_SOURCE_ID } from '../../errors';
import {
  DatasetMissingWorkflowError,
  DatasetNotAvailableWorkflowError,
  type WorkflowError,
} from '../../errors/workflow-error';
import { type SchemaWithValidationInfo } from '../../validation-context/schema-with-validation-info';

export function validateDataset(
  workflowId: string,
  nodeId: string,
  datasetId: string | undefined,
  schemas: Map<string | symbol, SchemaWithValidationInfo>,
): WorkflowError<any>[] {
  const errors: WorkflowError<any>[] = [];
  if (!datasetId) {
    errors.push(new DatasetMissingWorkflowError(workflowId, nodeId, DATASET_SOURCE_ID));
    return errors;
  }
  const datasetSchema = Array.from(schemas.values()).find((schema) => {
    return !!schema?.id && schema?.id === datasetId;
  });

  if (datasetSchema && !datasetSchema.validationInfo?.availableInCurrentProject) {
    errors.push(new DatasetNotAvailableWorkflowError(workflowId, nodeId, DATASET_SOURCE_ID));
  }

  return errors;
}
